import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ShieldCheck, Check, Trash2, Clock } from "lucide-react";

const ROLES = [
  { v: "viewer", l: "Görüntüleyen" },
  { v: "user", l: "Düzenleyen" },
  { v: "admin", l: "Yönetici" },
];

export default function AdminPanel() {
  const [users, setUsers] = useState([]);
  const load = () => api.get("/admin/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const patch = async (u, upd) => {
    try { await api.put(`/admin/users/${u.id}`, upd); toast.success("Güncellendi"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const remove = async (u) => {
    if (!window.confirm(`${u.name} silinsin mi?`)) return;
    try { await api.delete(`/admin/users/${u.id}`); toast.success("Silindi"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const pending = users.filter((u) => u.status === "pending");

  return (
    <div className="space-y-6 animate-in-up" data-testid="admin-page">
      <div>
        <h1 className="font-head text-3xl font-bold tracking-tight flex items-center gap-2">
          <ShieldCheck className="w-7 h-7 text-[#2563EB]" /> Yönetici Paneli
        </h1>
        <p className="text-[#94A3B8] text-sm mt-1">Üye onayı, ad-soyad/görev ve yetki düzenleme</p>
      </div>

      {pending.length > 0 && (
        <div className="bg-[rgba(245,158,11,0.1)] border border-[rgba(245,158,11,0.3)] rounded-xl p-4 text-sm text-[#F59E0B] flex items-center gap-2">
          <Clock className="w-4 h-4" /> {pending.length} onay bekleyen üye var.
        </div>
      )}

      <div className="bg-[#131A26] border border-[#212D40] rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[820px]" data-testid="admin-users-table">
            <thead>
              <tr className="text-left text-[#94A3B8] text-xs uppercase tracking-wider border-b border-[#212D40] bg-[#0F1520]">
                <th className="py-3 px-4">Ad Soyad</th>
                <th className="py-3 px-4">E-posta</th>
                <th className="py-3 px-4">Görev</th>
                <th className="py-3 px-4">Yetki</th>
                <th className="py-3 px-4">Durum</th>
                <th className="py-3 px-4"></th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="border-b border-[#1a2334] hover:bg-[#0F1520]" data-testid={`admin-user-${u.id}`}>
                  <td className="py-2.5 px-4">
                    <input defaultValue={u.name} onBlur={(e) => e.target.value !== u.name && patch(u, { name: e.target.value })}
                      className="bg-[#0F1520] border border-[#212D40] rounded px-2 py-1.5 text-sm w-40 outline-none focus:border-[#2563EB]" />
                  </td>
                  <td className="py-2.5 px-4 text-[#94A3B8]">{u.email}</td>
                  <td className="py-2.5 px-4">
                    <input defaultValue={u.title} placeholder="Görev" onBlur={(e) => e.target.value !== u.title && patch(u, { title: e.target.value })}
                      className="bg-[#0F1520] border border-[#212D40] rounded px-2 py-1.5 text-sm w-36 outline-none focus:border-[#2563EB]" />
                  </td>
                  <td className="py-2.5 px-4">
                    <select data-testid={`admin-role-${u.id}`} value={u.role} onChange={(e) => patch(u, { role: e.target.value })}
                      className="bg-[#0F1520] border border-[#212D40] rounded px-2 py-1.5 text-sm outline-none focus:border-[#2563EB]">
                      {ROLES.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
                    </select>
                  </td>
                  <td className="py-2.5 px-4">
                    <span className="text-xs font-semibold px-2.5 py-1 rounded-full"
                      style={u.status === "pending"
                        ? { color: "#F59E0B", background: "rgba(245,158,11,0.15)" }
                        : { color: "#10B981", background: "rgba(16,185,129,0.15)" }}>
                      {u.status === "pending" ? "Onay Bekliyor" : "Onaylı"}
                    </span>
                  </td>
                  <td className="py-2.5 px-4 text-right whitespace-nowrap">
                    {u.status === "pending" && (
                      <button data-testid={`admin-approve-${u.id}`} onClick={() => patch(u, { status: "approved", role: u.role === "viewer" ? "user" : u.role })}
                        className="inline-flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-lg bg-[rgba(16,185,129,0.15)] text-[#10B981] hover:bg-[rgba(16,185,129,0.25)] mr-2">
                        <Check className="w-3.5 h-3.5" /> Onayla
                      </button>
                    )}
                    <button onClick={() => remove(u)} className="text-[#64748B] hover:text-[#EF4444]"><Trash2 className="w-4 h-4" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
